import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { manualCashLimitPropertiesType } from '../../types';
import CreateButton from '../buttons/CreateButton';
import ManualCashLimitCreateTab from './ManualCashLimitCreateTab';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import { getCopyOfManualCashLimit } from '../../reducers';
import useEffectOnUpdate from '../../hooks/useEffectOnUpdate';

CreateManualCashLimitRow.propTypes = {
    manualCashLimitProps: manualCashLimitPropertiesType.isRequired,
};

function CreateManualCashLimitRow(props) {
    const {
        manualCashLimitProps,
    } = props;
    const { t } = useTranslation();
    const copyToCreate = useSelector(getCopyOfManualCashLimit);
    const [isCreateVisible, setCreateVisible] = useState(false);
    useEffectOnUpdate(() => {
        if (copyToCreate) {
            setCreateVisible(true);
        }
    }, [copyToCreate]);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-manual-cash-limit-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}>
                <FontAwesomeIcon icon="plus" />&nbsp;{t('manual-cash-limits.create-manual-cash-limit')}
            </CreateButton>
            {isCreateVisible && (
                <ManualCashLimitCreateTab
                    manualCashLimitProps={manualCashLimitProps}
                    hideHandler={() => setCreateVisible(false)}
                    copyToCreate={copyToCreate}
                />
            )}
        </div>
    );
}

export default withPrivileges([Privileges.MANUAL_CASH_LIMIT_EDIT])(CreateManualCashLimitRow);
